import { WechatPayMethod } from '../../../generated/graphql'
import { isMobileBrowser, isWeChatBrowser } from '../../../utils/browser'

/** Pick the right WeChat Pay method based on environment */
export function getWechatPayMethod(): WechatPayMethod {
  if (isWeChatBrowser()) return WechatPayMethod.Jsapi
  if (isMobileBrowser()) return WechatPayMethod.H5
  return WechatPayMethod.Native
}

/** Build H5 scene info JSON string */
export function buildH5SceneInfo(): string {
  const ua = navigator.userAgent
  let type = 'Wap'
  if (/iPhone|iPad|iPod/i.test(ua)) type = 'iOS'
  else if (/Android/i.test(ua)) type = 'Android'
  return JSON.stringify({ h5_info: { type } })
}
